import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d } }),
};

export const MaskedLines = ({ lines, className = "", delay = 0.15, stagger = 0.11, inView = false, testId }) => (
  <motion.span
    className={`block ${className}`}
    data-testid={testId}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span className="block will-change-transform" variants={lineVariants} custom={delay + i * stagger}>
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
